import React, { useRef, useEffect } from "react";
import { useSlate, useFocused } from "slate-react";
import { Editor, Range } from "slate";
import Portal from "./components/Portal";
import { positionHoverMenu } from "./positionHoverMenu";
import {
  ELEMENT_BLOCK_QUOTE,
  ELEMENT_BULLETED_LIST,
  ELEMENT_IMAGE,
  ELEMENT_LIST_ITEM,
  ELEMENT_NUMBERED_LIST,
  ELEMENT_PARAGRAPH,
} from "./Element";
import EditImageButton from "./components/toolbar/EditImageButton";
import HoverMenu from "./components/HoverMenu";
import getSelectionType from "./components/utils/getSelectionType";
import ToolbarLine from "./components/ToolbarLine";

const EditorSelectionHoverToolbar = () => {
  const ref = useRef();
  const editor = useSlate();
  const inFocus = useFocused();
  const selectionType = getSelectionType(editor);

  useEffect(() => {
    const element = ref.current;
    const { selection } = editor;

    if (!element || !selection) {
      return;
    }

    if (
      (selectionType === ELEMENT_PARAGRAPH ||
        selectionType === ELEMENT_BULLETED_LIST ||
        selectionType === ELEMENT_NUMBERED_LIST ||
        selectionType === ELEMENT_LIST_ITEM ||
        selectionType === ELEMENT_BLOCK_QUOTE) &&
      (!selection ||
        !inFocus ||
        Range.isCollapsed(selection) ||
        Editor.string(editor, selection) === "" ||
        selection.anchor.path[0] < 1)
    ) {
      element.removeAttribute("style");
      return;
    }

    if (selectionType === ELEMENT_IMAGE) {
      positionHoverMenu(element);
    }
  });

  return (
    <Portal>
      <HoverMenu ref={ref}>
        <ToolbarLine>
          <EditImageButton />
        </ToolbarLine>
      </HoverMenu>
    </Portal>
  );

  /*
  return (
    <Portal>
      <HoverMenu ref={ref}>
        <ToolbarLine>
          {(selectionType === ELEMENT_PARAGRAPH ||
            selectionType === ELEMENT_LIST_ITEM ||
            selectionType === ELEMENT_BULLETED_LIST ||
            selectionType === ELEMENT_NUMBERED_LIST ||
            selectionType === ELEMENT_BLOCK_QUOTE) && (
            <>
              <MarkButton format="bold" icon={ICON_FORMAT_BOLD} />
              <MarkButton format="italic" icon={ICON_FORMAT_ITALIC} />
              <MarkButton format="underline" icon={ICON_FORMAT_UNDERLINE} />
              <BlockButton format="heading-three" icon={ICON_HEADING_THREE} />
              <BlockButton format="heading-four" icon={ICON_HEADING_FOUR} />
              <BlockButton format="block-quote" icon={ICON_FORMAT_QUOTE} />
              <BlockButton format="numbered-list" icon={ICON_FORMAT_LIST_NUMBERED} />
              <BlockButton format="bulleted-list" icon={ICON_FORMAT_LIST_BULLETED} />
              <BlockButton format="left" icon={ICON_FORMAT_ALIGN_LEFT} />
              <BlockButton format="center" icon={ICON_FORMAT_ALIGN_CENTER} />
              <BlockButton format="right" icon={ICON_FORMAT_ALIGN_RIGHT} />
              <BlockButton format="justify" icon={ICON_FORMAT_ALIGN_JUSTIFY} />
              <ToggleLinkButton />
            </>
          )}
          {selectionType === ELEMENT_IMAGE && (
            <>
              <EditImageButton />
              <BlockButton format="left" icon={ICON_FORMAT_ALIGN_LEFT} />
              <BlockButton format="center" icon={ICON_FORMAT_ALIGN_CENTER} />
              <BlockButton format="right" icon={ICON_FORMAT_ALIGN_RIGHT} />
            </>
          )}
        </ToolbarLine>
      </HoverMenu>
    </Portal>
  );
  */
};

export default EditorSelectionHoverToolbar;
